import axios from "axios";


const BACKEND_API_URL = process.env.REACT_APP_API_URL || '__BACKEND_API__';
const api = axios.create({
    baseURL:BACKEND_API_URL+"/api/v1",
    withCredentials: true,
});

if (process.env.NODE_ENV === 'production') {
    axios.interceptors.request.use((config) => {
        // Força HTTPS alterando o protocolo da URL
        if (config.url.startsWith('http://')) {
            config.url = config.url.replace('http://', 'https://');
        }
        return config;
    });
}

//api.headers.post['Content-Type'] = 'application/json';

export default api